export default class AcceptDto {
  isAccepted: boolean = true;
}
